import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'core/api/queryKeys';
import { humanizeApiError } from 'core/errors/mapFieldErrors';
import { useI18n } from 'core/i18n/I18nProvider';
import { userApi } from 'features/home/home.api';
import { ErrorState, Skeleton } from 'shared/components/Feedback';
import { PageMeta } from 'shared/components/PageMeta';
import { formatDate } from 'shared/utilities/format';
import { SafeHtml } from 'shared/utilities/sanitize';

export function LegalDocumentPage({ type }) {
  const { t, locale } = useI18n();
  const query = useQuery({
    queryKey: queryKeys.legalCurrent,
    queryFn: () => userApi.currentLegal(),
  });
  const document = query.data?.[type];

  if (query.isLoading) {
    return <Skeleton rows={6} />;
  }
  if (query.isError) {
    return <ErrorState title={humanizeApiError(query.error, t)} onRetry={() => query.refetch()} retryLabel={t('actions.retry')} />;
  }

  return (
    <article className="legal-page">
      <PageMeta titleKey="meta.legal" />
      <header className="hero-band hero-band-page">
        <div className="hero-band-copy">
          <p className="kicker">{t(`legal.${type}`)}</p>
          <h1>{document?.title || t(`legal.${type}`)}</h1>
          {document ? (
            <p className="muted">
              {t('legal.version', { version: document.version })}
              {document.effective_at ? ` · ${t('legal.effective', { date: formatDate(document.effective_at, locale) })}` : ''}
            </p>
          ) : null}
        </div>
      </header>
      {document ? (
        <div className="card legal-content-card">
          <SafeHtml className="legal-content" html={document.content} />
        </div>
      ) : (
        <p className="muted">{t('legal.missing')}</p>
      )}
    </article>
  );
}
